import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-card">
      <div className="container-page grid gap-8 py-12 md:grid-cols-[1.5fr_1fr_1fr]">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
            Record the call, let AI do the write-up, and walk away with the next step already
            drafted. Built for reps who live in back-to-back conversations.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground">Product</h4>
          <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
            <li><Link to="/" className="hover:text-foreground">Overview</Link></li>
            <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
            <li><Link to="/download" className="hover:text-foreground">Download apps</Link></li>
            <li><Link to="/setup" className="hover:text-foreground">Setup guide</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground">Account</h4>
          <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
            <li><Link to="/signup" className="hover:text-foreground">Create free account</Link></li>
            <li><Link to="/login" className="hover:text-foreground">Sign in</Link></li>
            <li><Link to="/dashboard" className="hover:text-foreground">Dashboard</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-page flex flex-col items-center justify-between gap-2 py-5 text-xs text-muted-foreground sm:flex-row">
          <span>© {year} Next Step Followup. All rights reserved.</span>
          <span>Windows desktop apps · Free during launch</span>
        </div>
      </div>
    </footer>
  );
}
